
<div class="rating-view" style="padding: 10px 40px;width: 100%;overflow: auto;">
  <ng-container *ngIf="isEditing">
    <div class="response-labels">
      <label> Initial Text </label>
      <input type="text" name="initialText" [(ngModel)]="ratingConfig.initialText" (change)="emitUpdatedData()" placeholder="Enter initial text" />
    </div>
    <div class="response-labels">
      <label> Final Text </label>
      <input type="text" name="finalText" [(ngModel)]="ratingConfig.finalText" (change)="emitUpdatedData()" placeholder="Enter final text" />
    </div>
  </ng-container>
  <!-- <div class="preview">
    <div class="content-text">
      {{ratingConfig.initialText}}
    </div>
    <div class="rating" [ngClass]="{'selected': ratingConfig.rating == (i + 1)}" (click)="updateValue(i + 1)"
         *ngFor="let num of (getNumbers | numbersPipe); let i = index">
      <div> {{i + 1}} </div>
    </div>
    <div class="content-text">
      {{ratingConfig.finalText}}
    </div>
  </div> -->
  
  <div style="display:flex;justify-content: space-between;width:54%">
    <div style="word-break: break-all;padding:0px 5px 0px 0px;">
      {{ratingConfig.initialText}}
    </div>
    <div  style="word-break: break-all;padding:0px 5px 0px 0px;">
      {{ratingConfig.finalText}}
    </div>
  </div>
  <br/> 
  <div class="preview"  style="width:100%;padding:0px 0px !important;margin-top: -10px !important;">
    <div class="rating" [ngClass]="{'selected': ratingConfig.rating == (i + 1)}" (click)="updateValue(i + 1)"
        *ngFor="let num of (getNumbers | numbersPipe); let i = index">
      <div> {{i + 1}} </div>
    </div>
  </div>   
 
</div>
